﻿import { Polygon, MultiPolygon, LineString, MultiLineString, Point, MultiPoint, GeometryCollection } from 'ol/geom.js';
export { Utility };

const Utility = function () {

    // Define this
    var myUtility = this;

    // -- begin public variable -------------------------------------------------------------------

    // -- Date format --
    this.DATE_SEPARATOR = "-";
    this.DATE_FORMAT_YEAR = "yyyy";
    this.DATE_FORMAT_MONTH = "mm";
    this.DATE_FORMAT_DAY = "dd";

    // Hash reference
    this.hashReference = {};

    // Water Waste Functionality
    this.PipeProfile = {};

    // -- end public variable ---------------------------------------------------------------------

    // -- begin private variable ------------------------------------------------------------------

    // Save all ids off canvas open
    this._idArrayOpenCanvas = [];

    // -- end private variable --------------------------------------------------------------------

    // -- begin public method ---------------------------------------------------------------------
    
    /**
     * Remoce accent from string
     */
    this.RemoveAccents = function(stringInput)
    {
        const accents = "ÀÁÂÃÄÅàáâãäåßÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž";
        const accentsOut = "AAAAAAaaaaaaBOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz";
        return stringInput
          .split("")
          .map((letter, index) => {
              const accentIndex = accents.indexOf(letter);
              return accentIndex !== -1 ? accentsOut[accentIndex] : letter;
          })
          .join("");
    };

    /**
     * Get area polygon
     * @param {geometry} geom, geometry of polygon
     */
    this.AreaFunction = function (geom)
    {
        var arrayGeom = [];
        //if (geom instanceof GeometryCollection) {
        //    for (var g in geom.getGeometries())
        //        geos.push(geom.getGeometries()[g]);
        //} else
        arrayGeom = [geom];
        var area = 0;
        for (var i in arrayGeom)
            area += arrayGeom[i].getArea();
        return area;
    };

    /**
     * Length of geometry line
     * @param {any} geom - geometry
     * @returns {number} length
     */
    this.LengthLine = function (geom) {
        var geos = [];
        //if (geom instanceof GeometryCollection) {
        //    for (var g in geom.getGeometries())
        //        geos.push(geom.getGeometries()[g]);
        //} else
        geos = [geom];
        var l = 0;
        for (var g in geos)
            if (geom instanceof MultiLineString) {
                for (var i = 0; i < geos[g].getLineStrings().length; i++) {
                    l += geos[g].getLineStrings()[i].getLength();
                }
            }
            else
                l += geos[g].getLength();
        var length = Math.round(l * 100) / 100 + " m";

        return length;
    };


    /**
     * Utility
     * Fill any select
     * Array Struct:
     * [
     *  { propertyValue: '',
     *    propertyText: ''
     *  },
     *  ...
     * ]
     * @param {any} idNodeSelect, id node select
     * @param {any} arraySource, array source
     * @param {any} propertyText, property text
     * @param {any} propertyValue, property value
     * @param {bool} sortByText, sort array by text column 
     */
    this.FillSelect = function (idNodeSelect, arraySource, propertyText, propertyValue, sortByText) {
        // If no selection then leave
        if (!arraySource)
            return;

        // SortArray
        if(sortByText) {
            arraySource.sort((a,b) => ( a[propertyText] > b[propertyText])? 1:((b[propertyText] > a[propertyText])? -1: 0));
        }

        // Clean select
        $('#' + idNodeSelect).find('option[value]').remove();

        // Fill select
        var $select = $('#' + idNodeSelect);
        var obj = null;
        var $option = null;
        for (var t = 0; t < arraySource.length; t++) {
            obj = arraySource[t];
            $option = $("<option></option>", {
                "text": obj[propertyText],
                "value": obj[propertyValue]
            });
            $select.append($option);
        }
        $('#' + idNodeSelect).selectpicker("refresh");
    };

    /**
     * Utility
     * Fill any select
     * Array Struct:
     * [
     *  { propertyValue: '',
     *    propertyText: ''
     *  },
     *  ...
     * ]
     * @param {any} idNodeSelect, id node select
     * @param {any} arraySource, array source
     * @param {any} propertyText, property text
     * @param {any} propertyValue, property value
     * @param {bool} sortByText, sort array by text column 
     */
    this.FillSelectNormal = function (idNodeSelect, arraySource, propertyText, propertyValue, sortByText) {
        // If no selection then leave
        if (!arraySource)
            return;

        // SortArray
        if (sortByText) {
            arraySource.sort((a, b) => (a[propertyText] > b[propertyText]) ? 1 : ((b[propertyText] > a[propertyText]) ? -1 : 0));
        }

        // Clean select
        $('#' + idNodeSelect).find('option[value]').remove();

        // Fill select
        var $select = $('#' + idNodeSelect);
        var obj = null;
        var $option = null;
        for (var t = 0; t < arraySource.length; t++) {
            obj = arraySource[t];
            $option = $("<option></option>", {
                "text": obj[propertyText],
                "value": obj[propertyValue]
            });
            $select.append($option);
        }
    };

    /**
     * Utility
     * Fill any select
     * Array Struct:
     * [
     *  { propertyValue: '',
     *    propertyText: ''
     *  },
     *  ...
     * ]
     * @param {any} idNodeSelect, id node select
     * @param {any} arraySource, array source
     * @param {any} propertyText, property text
     * @param {any} propertyValue, property value
     * @param {bool} sortByText, sort array by text column 
     */
    this.FillSelect2Value = function (idNodeSelect, arraySource, propertyText, propertyValue, propertyValue2, sortByText) {
        // If no selection then leave
        if (!arraySource)
            return;

        // SortArray
        if(sortByText) {
            arraySource.sort((a,b) => ( a[propertyText] > b[propertyText])? 1:((b[propertyText] > a[propertyText])? -1: 0));
        }

        // Clean select
        $('#' + idNodeSelect).find('option[value]').remove();

        // Fill select
        var $select = $('#' + idNodeSelect);
        var obj = null;
        var $option = null;
        for (var t = 0; t < arraySource.length; t++) {
            obj = arraySource[t];
            $option = $("<option></option>", {
                "text": obj[propertyText],
                "value": obj[propertyValue],
                "value2": obj[propertyValue2],
            });
            $select.append($option);
        }
        $('#' + idNodeSelect).selectpicker("refresh");
    };

    /**
     * Get show wait spinner html
     * @param {string} idSpinner, id spinner node
     * @param {string} classSpinner, add class spinner
     * @param {bool} visible, whit visible spinner
     * @return {string} html of the spinner
     */
    this.GetShowWaitHtml = function (idSpinner, classSpinner, visible) {
        var olHidden = 'ol-hidden';
        if (visible)
            olHidden = '';

        return '<div id="' + idSpinner + '" class="loader map-spinner ' + olHidden + ' ' + classSpinner + '">' +
            '<div class="preloader ' + classSpinner + '">' +
            '<div class="spinner-layer pl-red">' +
            '<div class="circle-clipper left">' +
            '<div class="circle"></div>' +
            '</div>' +
            '<div class="circle-clipper right">' +
            '<div class="circle"></div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '<p style="background: white; padding: 10px">Aguarde...</p>' +
            '</div>';
    };

    /**
     * Add show wait spinner to a node
     * @param {string} idSpinner, id spinner
     * @param {string} classSpinner, class spinner
     * @param {string} idAppend, id node to append
     * @param {bool} visible, whit visible spinner
     */
    this.SetShowWait = function (idSpinner, classSpinner, idAppend, visible) {
        // Get spinner html
        var showWaitHtml = myUtility.GetShowWaitHtml(idSpinner, classSpinner, visible);

        // Append
        $('#' + idAppend).append($(showWaitHtml));
    };

    /**
     * Show wait spinner
     * @param {string} idSpinner, spinner node id
     * @param {bool} visible, whit visible spinner
     */
    this.ShowWait = function (idSpinner, visible) {
        if (visible)
            $('#' + idSpinner).removeClass('ol-hidden');
        else
            $('#' + idSpinner).addClass('ol-hidden');
    };

    /**
     * Show wait spinner
     * @param {string} idSpinner, spinner node id
     * @param {bool} visible, whit visible spinner
     */
    this.ShowWait2 = function (idSpinner) {
        $('#' + idSpinner).toggle('ol-hidden');
    };

    /**
     * Init toastr
     * @param{string} showDuration, duration toastr msg duration
     */
    this.InitToastr = function (showDuration) {
        toastr.options = {
            "closeButton": true,
            "debug": false,
            "newestOnTop": false,
            "progressBar": false,
            "positionClass": "toast-bottom-center",
            "preventDuplicates": false,
            "onclick": null,
            "showDuration": showDuration,
            "hideDuration": "1000",
            "timeOut": showDuration,
            "extendedTimeOut": "1000",
            "showEasing": "swing",
            "hideEasing": "linear",
            "showMethod": "fadeIn",
            "hideMethod": "fadeOut"
        };
    };

    /**
     * Hold button effect
     * @param {string} idMainMenu, id element main menu
     * @param {string} idElementButton, id element <a> of the button
     */
    this.HoldButtonEffect = function (idMainMenu, idElementButton) {
        var currentIdButton = $('#' + idMainMenu).attr('current-id-button');

        if (currentIdButton === idElementButton) {
            $('#' + idElementButton).removeClass('hold-button');
            $('#' + idMainMenu).attr('current-id-button', '');
        }
        else {
            if (currentIdButton)
                $('#' + currentIdButton).removeClass('hold-button');

            if ($('#' + idElementButton).hasClass('hold-button')) {
                $('#' + idElementButton).removeClass('hold-button');
                $('#' + idMainMenu).attr('current-id-button', '');
            }
            else {
                $('#' + idElementButton).addClass('hold-button');
                $('#' + idMainMenu).attr('current-id-button', idElementButton);
            }
        }
    };

    /**
     * Remove class active from <li> button
     * @param {any} idButtonClick, id button clicked
     */
    this.RemoveActiveButton = function (idButtonClick) {
        $('.target').not('#' + idButtonClick).parent().removeClass('active');
    };

    /**
     * Remove class active from <li> button
     * @param {string} idMenu, id menu
     * @param {string} idButtonClick, id button clicked
     */
    this.RemoveActiveButtonInMenu = function (idMenu, idButtonClick) {
        $('#' + idMenu).not('#' + idButtonClick).parent().removeClass('active');
    };

    /**
     * Get layer by name
     * @param {ol.map} map, map
     * @param {any} layerName, layer name
     * @returns {ol.layer} layer
     */
    this.GetLayerByName = function (map, layerName) {
        var rLayer;

        var layerArray = map.getLayers().getArray();

        //layers.forEach(function (layer) {
        //    if (layer.getProperties().name === layerName) {
        //        rLayer = layer;
        //    }
        //});
        for (const layer of layerArray) {
            if (layer.getProperties().name === layerName) {
                rLayer = layer;
                break;
            }
        }

        return rLayer;
    };

    /**
     * Get layer position
     * @param {ol.map} map, map
     * @param {any} layerName, layer name
     * @returns {ol.layer} layer
     */
    this.GetLayerPositionByName = function (map, layerName) {
        var position = -1;
        var layerArray = map.getLayers().getArray();

        for (var i = 0; i < layerArray.length; i++) {
            var layer = layerArray[i]
            if (layer.getProperties().name === layerName) {
                position = i;
                break;
            }
        }

        return position;
    };

    /**
     * Get layer by id
     * @param {ol.map} map, map
     * @param {any} id, id layer
     * @returns {ol.layer} layer
     */
    this.GetLayerById = function (map, id) {
        var rLayer;

        var layers = map.getLayers();

        layers.forEach(function (layer) {
            if (layer.getProperties().id === id) {
                rLayer = layer;
            return;
        }
        });

        return rLayer;
    };

    /**
     * Get the value of an URL paramter
     * @param {string} parameterName, The name of the parameter
     * @return {string} value of the parameter 
     */
    this.GetURLParamValue = function (parameterName) {
        var result = null,
            tmp = [];
        location.search
            .substr(1)
            .split("&")
            .forEach(function (item) {
                tmp = item.split("=");
                if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
            });
        return result;
    };

    /**
     * Convert m2 to ha
     * @param {number} value - Any value
     * @returns {number} - Value in ha
     */
    this.ConvertToHa = function (value) {

        return value / 10000;
    };

    /**
     * Transforme date server in date
     * @param {string} dateValue, value of the date
     * @param {string} formatDate, date formart
     * @param {string} separator, date separator
     * @return {string} date
     */
    this.getNewDateForServer = function (dateValue, formatDate, separator) {
        var newDate = new Date();
        var day = newDate.getDate();
        var month = newDate.getMonth() + 1;
        var year = newDate.getFullYear();
        day = day.toString().length == 1 ? '0' + day : day;
        month = month.toString().length == 1 ? '0' + month : month;

        return year + "-" + month + "-" + day + "T" + newDate.toLocaleTimeString('pt-PT');
    };

    /**
     * Transforme date MM-DD-YYYY
     * @return {string} date
     */
    this.GetNowDate = function () {
        var newDate = new Date();
        var day = newDate.getDate();
        var month = newDate.getMonth() + 1;
        var year = newDate.getFullYear();
        day = day.toString().length == 1 ? '0' + day : day;
        month = month.toString().length == 1 ? '0' + month : month;

        return day + "-" + month + "-" + year;
    };

    /**
     * Transforme date server in date
     * @param {string} dateValue, value of the date
     * @param {string} formatDate, date formart
     * @param {string} separator, date separator
     * @return {string} date
     */
    this.TransformDateServerInDate = function (dateValue, formatDate, separator) {
        var dateObj = new Date(myUtility.GetDateComponent(formatDate, separator, myUtility.DATE_FORMAT_YEAR, dateValue), parseInt(myUtility.GetDateComponent(formatDate, separator, myUtility.DATE_FORMAT_MONTH, dateValue)) - 1, myUtility.GetDateComponent(formatDate, separator, myUtility.DATE_FORMAT_DAY, dateValue));
        var dateValueResult = myUtility.PadLeft(dateObj.getDate(), 2) + myUtility.DATE_SEPARATOR + myUtility.PadLeft(dateObj.getMonth() + 1, 2) + myUtility.DATE_SEPARATOR + dateObj.getFullYear();

        return dateValueResult;
    };

    /**
     * Transforme date server in date
     * @param {string} dateValueInput, value of the date
     * @return {string} date
     */
	this.TransformDateServerInDateII = function (dateValueInput) {
        if (dateValueInput) {
            var formatDate = "yyyy-mm-dd";
            var separator = "-";
            var dateValue = dateValueInput.substr(0, 10);
            var dateObj = new Date(myUtility.GetDateComponent(formatDate, separator, myUtility.DATE_FORMAT_YEAR, dateValue), parseInt(myUtility.GetDateComponent(formatDate, separator, myUtility.DATE_FORMAT_MONTH, dateValue)) - 1, myUtility.GetDateComponent(formatDate, separator, myUtility.DATE_FORMAT_DAY, dateValue));
            var dateValueResult = dateObj.getFullYear() + myUtility.DATE_SEPARATOR + myUtility.PadLeft(dateObj.getMonth() + 1, 2) + myUtility.DATE_SEPARATOR + myUtility.PadLeft(dateObj.getDate(), 2);

            return dateValueResult;
        }
        else
            return dateValueInput;
    };

    /**
     * Transforme date server in date whit hour and minute
     * @param {string} dateValueInput, value of the date
     * @return {string} date
     */
    this.TransformDateServerInDateTime = function (dateValueInput) {
        if (dateValueInput) {
            var formatDate = "yyyy-mm-dd";
            var separator = "-";
            var dateValue = dateValueInput.substr(0, 10);
            var dateObj = new Date(myUtility.GetDateComponent(formatDate, separator, myUtility.DATE_FORMAT_YEAR, dateValue), parseInt(myUtility.GetDateComponent(formatDate, separator, myUtility.DATE_FORMAT_MONTH, dateValue)) - 1, myUtility.GetDateComponent(formatDate, separator, myUtility.DATE_FORMAT_DAY, dateValue));
            var dateValueResult = dateObj.getFullYear() + myUtility.DATE_SEPARATOR + myUtility.PadLeft(dateObj.getMonth() + 1, 2) + myUtility.DATE_SEPARATOR + myUtility.PadLeft(dateObj.getDate(), 2);
            // Add hour and minute
            var time = dateValueInput.substring(11);
            if(time)
                dateValueResult += " " + time.split(':')[0] + ":" + time.split(':')[1];

            return dateValueResult;
        }
        else
            return dateValueInput;
    };

    /**
     * Get date component
     * @param {string} dateFormat, date formart
     * @param {string} dateSeparator, date separator
     * @param {string} component, date component (year, month or day)
     * @param {string} dateValue, value of the date
     * @return {array} array date component
     */
    this.GetDateComponent = function (dateFormat, dateSeparator, component, dateValue) {
        var arrayFormat = dateFormat.split(dateSeparator);
        var arrayDate = dateValue.split(dateSeparator);
        var posComponent = -1;

        for (var i = 0; i < arrayFormat.length; i++) {
            if (arrayFormat[i] === component)
                posComponent = i;
        }

        return arrayDate[posComponent];
    };

    /**
     * Add zero to the left of the string
     * @param {string} num, string input
     * @param {string} size, size of zero to be added
     * @return {string} result
     */
    this.PadLeft = function (num, size) {
        var s = num + "";
        while (s.length < size) s = "0" + s;

        return s;
	};

	/**
	 * Function to get all ID canvas open
	 * @param {any} show true/false to open/close canvas
	 */
	this.ShowOpenCanvas = function (show, idnode, nodeShow) {
		
		$('.canvasShow').each(function () {
			if ($(this).hasClass('active')) {
				myUtility._idArrayOpenCanvas.push(this.id);
			}
		});
        myUtility.ShowCanvas(myUtility._idArrayOpenCanvas, show)

        if (idnode)
            myUtility.ShowCanvas(idnode, nodeShow);
    }

	/**
	 * Function to open or close canvas
	 * @param {string} idnode id canvas to open
	 * @param {boolean} show true/false to open/close canvas
	 */
	this.ShowCanvas = function (idnode, show) {

		var _lengthArrayOpenCanvas = idnode.length

		for (var i = 0; i < _lengthArrayOpenCanvas; i++) {
            if (show) {
                if (idnode[i] !== 'map-search' && idnode[i] !== 'offcanvas-map-list' && idnode[i] !== 'map-event-search')
                    $('#' + idnode[i]).css({ 'transform': 'translate(-319px, 0px)' });
                else if (idnode[i] === 'offcanvas-map-list') {
                    var sizeTranslate = ($(window).width() - $('#offcanvas-map-list').width());
                    sizeTranslate = ($(window).width() - sizeTranslate);
                    $('#' + idnode[i]).css({ 'transform': 'translate(-' + sizeTranslate + 'px, 0px)' });
                }
				$('#' + idnode[i]).addClass('active');
			}
			else {
                if (idnode[i] !== 'map-search' && idnode[i] !== 'map-event-search')
                    $('#' + idnode[i]).css({ 'transform': '' });
                else if (myUtility.mobilecheck()){
                    var sizecanvas = 320 - $('#'+idnode[i]).width()
                    $('#' + idnode[i]).css({ 'transform': 'translate(' + sizecanvas  + 'px, 0px)' });
                }
                $('#' + idnode[i]).removeClass('active');
                
            }
            if (myUtility.mobilecheck() && show) {
                $('#' + idnode[i]).css({ 'transform': 'translate(-' + $(window).width()+'px , 0px)' }); 
            }
		}
		if (show) {
			myUtility._idArrayOpenCanvas = [ ];
		}
    }

    /**
     * Function to get all ID canvas open
     * @param {any} show true/false to open/close canvas
     */
    this.ShowOpenCanvas2 = function (show, idnode, nodeShow, xTranslate) {

        $('.canvasShow').each(function () {
            if ($(this).hasClass('active')) {
                myUtility._idArrayOpenCanvas.push(this.id);
            }
        });
        myUtility.ShowCanvas2(myUtility._idArrayOpenCanvas, show, xTranslate)

        if (idnode)
            myUtility.ShowCanvas2(idnode, nodeShow, xTranslate);
    }

    /**
     * Function to open or close canvas
     * @param {string} idnode id canvas to open
     * @param {boolean} show true/false to open/close canvas
     */
    this.ShowCanvas2 = function (idnode, show, xTranslate) {

        var _lengthArrayOpenCanvas = idnode.length

        for (var i = 0; i < _lengthArrayOpenCanvas; i++) {
            if (show) {
                if (idnode[i] !== 'map-search' && idnode[i] !== 'offcanvas-map-list' && idnode[i] !== 'map-event-search')
                    $('#' + idnode[i]).css({ 'transform': 'translate(' + xTranslate + 'px, 0px)' });
                else if (idnode[i] === 'offcanvas-map-list') {
                    var sizeTranslate = ($(window).width() - $('#offcanvas-map-list').width());
                    sizeTranslate = ($(window).width() - sizeTranslate);
                    $('#' + idnode[i]).css({ 'transform': 'translate(-' + sizeTranslate + 'px, 0px)' });
                }
                $('#' + idnode[i]).addClass('active');
                $('#' + idnode[i]).addClass('offcanvas-z-index');
            }
            else {
                if (idnode[i] !== 'map-search' && idnode[i] !== 'map-event-search')
                    $('#' + idnode[i]).css({ 'transform': '' });
                else if (myUtility.mobilecheck()) {
                    var sizecanvas = 320 - $('#' + idnode[i]).width()
                    $('#' + idnode[i]).css({ 'transform': 'translate(' + sizecanvas + 'px, 0px)' });
                }
                $('#' + idnode[i]).removeClass('active');
                $('#' + idnode[i]).removeClass('offcanvas-z-index');
            }
            if (myUtility.mobilecheck() && show) {
                $('#' + idnode[i]).css({ 'transform': 'translate(-' + $(window).width() + 'px , 0px)' });
            }
        }
        if (show) {
            myUtility._idArrayOpenCanvas = [];
        }
    }

    /**
     * Function to get all ID canvas open
     * @param {any} show true/false to open/close canvas
     */
    this.ShowOpenCanvas3 = function (idnode, nodeShow) {

        if (nodeShow) {
            _controlOffCanvas.openOffcanvas("#" + idnode);
        }
        else {
            _controlOffCanvas.closeOffcanvas();
        }
    }

    /**
     * Check if the browser is mobile 
     */
    this.mobilecheck = function () {
        var check = false;
        (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
    };

    /**
     * Utility
     * Get decimal separator
     */
    this.WhatDecimalSeparator = function() {
        var n = 1.1;
        n = n.toLocaleString().substring(1, 2);
        return n;
    }

    /**
     * Valid number
     * @param {string} 
     */
    this.ValidNumber = function(numberStr) {
        var lengthValue = numberStr;
        var decimalValue = myUtility.WhatDecimalSeparator();
        var idNode = $(this)[0].id;

        if (lengthValue != "") {
            if (lengthValue.search(new RegExp('^[0-9]\+$')) == -1 && lengthValue.search(new RegExp('^[0-9]\+' + decimalValue + '[0-9]\+$')) == -1) {
                return false;
            }
            else {
                return true;
            }
        }
        else {
            return true;
        }
    }

    /**
     * Set Scale in combo
     * @param {strig} idNodeSelect, node select identifier
     * @param {int} fromScale, from scale value
     * @param {int} toScale, to scale value
     * @param {int} scaleSelected, scale selected
     * @param {string} orderBy, scale order option: asc or desc
     * @param {bool} async, true for async call
     */
    this.SetSelectScaleFromRange = function (idNodeSelect, fromScale, toScale, scaleSelected, orderBy, async) {

        if (!myUtility.hashReference["scale_range"]) {
            $.ajax({
                type: 'GET',
                url: '/rest/app/LayerRef/GetScalesFromRange?fromScale=' + fromScale + '&toScale=' + toScale + "&orderBy=" + orderBy,
                async: async,
                success: function (data) {
                    if (data.error) {
                        toastr["error"]("Erro de carregamento da informação de escalas");
                    }
                    else {
                        switch (data.result.status) {
                            case 'SUCCESS':
                                // Fill Scale
                                myUtility.hashReference["scale_range"] = data.result.list_scale;
                                myUtility.FillSelect(idNodeSelect, data.result.list_scale, 'description', 'scales');
                                // set begin scale
                                if (scaleSelected) {
                                    $('#' + idNodeSelect).val(scaleSelected)
                                    $('#' + idNodeSelect).selectpicker("refresh");
                                }
                                break;
                            case 'ERROR':
                                toastr["error"]("Erro de carregamento da informação de escalas");
                                break;
                            default:
                        }
                    }
                },
                error: function (request, status, error) {
                    toastr["error"]("Erro de carregamento da informação de escalas");
                }
            });
        }
        else {
            //if (myUtility.hashReference["scale_range"][0].description == "1:1000")
            //    myUtility.hashReference["scale_range"].splice(0, 1);
            myUtility.FillSelect(idNodeSelect, myUtility.hashReference["scale_range"], 'description', 'scales');

            // set begin scale
            if (scaleSelected) {
                $('#' + idNodeSelect).val(scaleSelected)
                $('#' + idNodeSelect).selectpicker("refresh");
            }
        }
    };

    /**
     * Set Scale array in combo
     * @param {strig} idNodeSelect, node select identifier
     * @param {array} arrayScale, array of scale
     * @param {int} scaleSelectedDefault, scale selected by default
     */
    this.SetScaleInSelect = function (idNodeSelect, arrayScale, scaleSelectedDefault) {
        // Transform in array of object
        var arrayScaleInObj = [];
        for(var i = 0; i < arrayScale.length; i++) {
            var scaleValue = arrayScale[i];
            arrayScaleInObj.push({
                "description": "1:" + scaleValue,
                "scale": scaleValue
            })
        }

        // Fill select
        myUtility.FillSelect(idNodeSelect, arrayScaleInObj, 'description', 'scale');

        // set begin scale
        if (scaleSelectedDefault) {
            $('#' + idNodeSelect).val(scaleSelectedDefault)
            $('#' + idNodeSelect).selectpicker("refresh");
        }
    };

    /**
     * conversion lat in DD to DMS.
     * @param {float} lat, latitude
     * @param {float} lng, longitude
     */
    this.DdToDms = function(lat, lng) {

        var lat = lat;
        var lng = lng;
        var result = {
            latitude: null,
            longitude: null
        }

        lat = parseFloat(lat);
        lng = parseFloat(lng);

        // Call to getDms(lat) function for the coordinates of Latitude in DMS.
        // The result is stored in latResult variable.
        result.latitude =  myUtility.GetDms(lat);
        result.latitude.direction = (lat >= 0) ? 'N' : 'S';;

        // Call to getDms(lng) function for the coordinates of Longitude in DMS.
        // The result is stored in lngResult variable.
        result.longitude = myUtility.GetDms(lng);
        result.longitude.direction = (lng >= 0) ? 'E' : 'W';;

        return result;
    }

    /**
     * Transform decimal coordinate to degree coordinate
     * @param {float} val, coordinate
     */
    this.GetDms = function (val) {

        var result = {
            degree: null,
            minute: null,
            second: null
        }

        val = Math.abs(val);

        result.degree = Math.floor(val);
        result.minute = Math.floor((val - result.degree) * 60);
        result.second = Math.round((val - result.degree - result.minute / 60) * 3600 * 1000) / 1000;

        return result;
    }

    this.SendEmail = function (EmailData) {

        $.ajax({
            type: 'POST',
            url: '/rest/app/EmailManager/RegisterAndSendEmail',
            data: JSON.stringify(EmailData),
            dataType: 'json',
            contentType: "application/json",
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro no envio da mensagem");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            if (typeof data.result.cod_state != 'undefined' && data.result.cod_state == 'SEND_ERROR') {
                                toastr["warning"]("Mensagem não enviada");
                            } else {
                                toastr["success"]("Mensagem enviada");
                            }
                            $('#id-modal-email').css({ 'display': 'none' });
                            break;
                        case 'NOT_FOUND':
                            toastr["warning"]("Mensagem não enviada");
                            break;
                        case 'ERROR':
                            toastr["error"]("Erro no envio da mensagem");
                            break;
                        default:
                    }
                }
            },
            error: function (request, status, error) {
                toastr["error"]("Erro no envio da mensagem");
            }

        });

    }

    this.SendOnlyEmail = function (EmailInfo) {

        $.ajax({
            type: 'POST',
            url: '/rest/app/EmailManager/SendEmail',
            data: JSON.stringify(EmailInfo),
            dataType: 'json',
            contentType: "application/json",
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro no envio da mensagem");
                }
                else {
                    switch (data.result) {
                        case 'true':
                            toastr["success"]("Mensagem enviada");
                            break;
                        case 'false':
                            toastr["error"]("Mensagem não enviada");
                            break;
                        default:
                    }
                }
            },
            error: function (request, status, error) {
                toastr["error"]("Erro no envio da mensagem");
            }

        });

    }

    /**
     * Check if image exists
     * @param {string} imageUrl, image url
     */
    this.ImageExists = function(imageUrl) {
        try {
            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function () {
                if (this.readyState == 4) {
                    return this.status !== 404
                }
            };
            xhr.open('HEAD', imageUrl, false);
            xhr.send();
        }
        catch (e) {
            return false;
        }
        
    }    

    /**
     *  Clean filds by Idobject
     */
    this.CleanFieldsbyObject = function (Idobject) {

        var _objectserialize = $(Idobject).serializeJSON();

        var _objectKeys = Object.keys(_objectserialize);

        for (var i = 0; i < _objectKeys.length; i++) {
            $(Idobject + ' [name=' + _objectKeys[i] + ']').val('').selectpicker("refresh");
        }

    }

    /**
     *  Submit Form
     *  Fulfills a form action button click, given a button ID (data-formbutton attribute)
     */
    this.SubmitForm = function (event) {
        var submitBtn = event.target.getAttribute('data-formbutton');
        if (submitBtn) $('#' + submitBtn).click();
        event.preventDefault();
    }

    /**
     * Lower first letter in string
     * @param {string} string, string to lower
     */
    this.LowerFirstString = function(string) {
        if (typeof string == "undefined") return "";
        return string.charAt(0).toLowerCase() + string.slice(1);
    }

    /**
     * Capitalize first string
     * @param {string} string, string to capitalize
     */
    this.CapitalizeFirstString = function(string) {
        if (typeof string == "undefined") return "";
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    /**
     * Capitalize all string
     * @param {string} string, string to capitalize
     */
    this.CapitalizeAllString = function(string) {
        if(string === null || string === undefined)
            return "";
        var str = string.toString().toLowerCase()
        var arrayWordException = ['de','da','do','a','o'];

        return str.replace(
              /\w\S*/g,
              function(txt) {
                  if(arrayWordException.indexOf(txt) >= 0) return txt;
                  return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
              }
          );
    }

    /**
     * Get property value from property info
     */
    this.GetPropertyInfoInConfigArray = function(arrayConfigInfo, codGroup, codContext, codProperty) {
        return arrayConfigInfo.find(c => c.cod_group == codGroup && c.cod_context == codContext && c.cod_property == codProperty);
    }

    /**
     * Get property value from property info Multi
     */
    this.GetPropertyInfoInConfigArrayMulti = function (arrayConfigInfo, codGroup, codContext, codProperty) {
        return arrayConfigInfo.filter(c => c.cod_group == codGroup && c.cod_context == codContext && c.cod_property == codProperty);
    }

    /**
     * Calulate bounds from center, resolution and size
     * @param {object} coordCenter, center coordinate
     * @param {float} resolution, scale resolution
     * @param {int} width, size width
     * @param {int} height, size height
     */
    this.GetBounds = function(coordCenter, resolution, width, height) {
        var widthHalf = (width * resolution) / 2;
        var heightHalf = (height * resolution) / 2;
        return [coordCenter[0]-widthHalf, coordCenter[1]-heightHalf, coordCenter[0]+widthHalf, coordCenter[1]+heightHalf];
    }

    /**
     * Transform url image
     * @param {object} coordCenter, center coordinate
     * @param {float} resolution, scale resolution
     * @param {int} width, size width
     * @param {int} height, size height
     */
    this.GetBase64Image = function(imgUrl) {
        var baseImage = new Image();
        baseImage.setAttribute('crossOrigin', 'anonymous');
        baseImage.src = imgUrl;
        var canvas = document.createElement("canvas");
        canvas.width = baseImage.width;
        canvas.height = baseImage.height;
        var ctx = canvas.getContext("2d");
        ctx.drawImage(baseImage, 0, 0);
        var dataURL = canvas.toDataURL("image/png");
        return dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
    }

    this.ToDataUrl = function(url, callback) {
        var xhr = new XMLHttpRequest();
        xhr.onload = function() {
            var reader = new FileReader();
            reader.onloadend = function() {
                callback(reader.result);
            }
            reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
    }

    /**
     * Get Layer information
     * @param {string} layerName
     * @param {object} objLayerInformation, object fill by reference with the layer information
     */
    this.GetLayerInformation = function(layerName, objLayerInformation)
    {
    
        $.ajax({
            type: 'GET',
            url: '/rest/app/Layer/GetLayerSourceByName?layerName=' + layerName,
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na obtenção de informação de camadas");
                }
                else
                {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            objLayerInformation[layerName] = data.result.layerSource;
                            break;
                        case 'ERROR':
                            toastr["error"]("Erro na obtenção de informação de camadas");
                            break;
                        default:
                    }
                }
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na obtenção de informação de camadas");
            }
        });
    }

    /**
     * Sleep
     */
    this.Sleep = function(ms)
    {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    /**
     * Get key by value
     * @param {object} object, object where to find key
     * @param {value} value, value containt in object
     */
    this.GetKeyByValue = function (object, value) {
        return Object.keys(object).find(key => object[key] === value);
    }

    // -- end public method -----------------------------------------------------------------------
       
    // -- begin class area ------------------------------------------------------------------------

    /**
     * Class ExportPDF
     */
    this._exportTool = new function () {

        var exportPDF = this;

        this.scaleFactor = 2;

        this.pageStatus = {
            pdfObj: "",
            pageList: [],
            currentPage: 0,
            pageImages: [],
            borders: []
        };

        this.buildPDF = function () {

            exportPDF.pageStatus.pdfObj.save('Report.pdf');

            exportPDF.ShowWait(false);
        };

        this.setDPI = function(canvas, dpi) {
            // Set up CSS size.
            canvas.style.width = canvas.style.width || canvas.width + 'px';
            canvas.style.height = canvas.style.height || canvas.height + 'px';

            // Get size information.
            var scaleFactor = dpi / 96;
            var width = parseFloat(canvas.style.width);
            var height = parseFloat(canvas.style.height);

            // Backup the canvas contents.
            var oldScale = canvas.width / width;
            var backupScale = scaleFactor / oldScale;
            var backup = canvas.cloneNode(false);
            backup.getContext('2d').drawImage(canvas, 0, 0);

            // Resize the canvas.
            var ctx = canvas.getContext('2d');
            canvas.width = Math.ceil(width * scaleFactor);
            canvas.height = Math.ceil(height * scaleFactor);

            // Redraw the canvas image and scale future draws.
            ctx.setTransform(backupScale, 0, 0, backupScale, 0, 0);
            ctx.drawImage(backup, 0, 0);
            ctx.setTransform(scaleFactor, 0, 0, scaleFactor, 0, 0);
        };


        this.extractBorder = function (element, borderType) {

            var border = {};
            // Extracts element border.
            if (borderType == "bottom") {
                border = {
                    rect: element.getBoundingClientRect(),
                    width: parseFloat($(element).css('border-bottom-width')),
                    style: $(element).css('border-bottom-style'),
                    color: $(element).css('border-bottom-color'),
                    original: $(element).css('border-bottom'),
                    element: element
                };
                // Clears original border.
                $(element).css('border-bottom-style', "none");
            }

            if (borderType == "right") {
                border = {
                    rect: element.getBoundingClientRect(),
                    width: parseFloat($(element).css('border-right-width')),
                    style: $(element).css('border-right-style'),
                    color: $(element).css('border-right-color'),
                    original: $(element).css('border-right'),
                    element: element
                };
                // Clears original border.
                $(element).css('border-right-style', "none");
            }


            return border;
        };

        this.extractBorders = function(element, borderType) {
            var borders = [];

            // Extracts the rect from the element itself.
            if (borderType == "bottom") {
                if ($(element).css('border-bottom-style')) {
                    borders.push(exportPDF.extractBorder(element, borderType));
                }
            }

            if (borderType == "right") {
                if ($(element).css('border-right-style')) {
                    borders.push(exportPDF.extractBorder(element, borderType));
                }
            }

            return borders;
        };

        this.drawBorder = function(canvas, borders, borderType) {
            // Retrieves context.
            var ctx = canvas.getContext("2d");

            for (var i = 0; i < borders.length; i++) {

                var border = borders[i][0];
                // Checks border style.
                if (border.style === "dashed") {
                    ctx.setLineDash([3]);
                } else if (border.style === "dotted") {
                    ctx.setLineDash([border.width]);
                }

                // Calculates border edges.                
                var left = border.rect.left + 9;
                var right = border.rect.right + 9;
                var bottom = border.rect.bottom;
                var top = border.rect.top;

                // Draws border.
                ctx.beginPath();

                if (borderType == "bottom") {
                    ctx.moveTo(left, bottom);
                    ctx.lineTo(right, bottom);
                }

                if (borderType == "right") {
                    ctx.moveTo(right, bottom);
                    ctx.lineTo(right, top);
                }

                ctx.strokeStyle = border.color;
                ctx.lineWidth = border.width;
                ctx.stroke();

                // Restores element original border
                if (borderType == "bottom") {
                    $(border.element).css('border-bottom', border.original);
                }

                if (borderType == "right") {
                    $(border.element).css('border-right', border.original);
                }

            }

        };

        this.composePages = function (callback) {

            var pageStatus = exportPDF.pageStatus;

            var parentRect = {
                id: pageStatus.currentPage,
                boundingBox: $(pageStatus.pageList[pageStatus.currentPage])[0].getBoundingClientRect(),
                borders: {
                    bottom: [],
                    right: []
                }
            }

            // Extracts elements borders.
            //$(pageStatus.pageList[pageStatus.currentPage]).find('.dashed-right').each(function () {
            //    parentRect.borders.right.push(exportPDF.extractBorders($(this)[0], 'right'));
            //});
            //$(pageStatus.pageList[pageStatus.currentPage]).find('.dashed-bottom').each(function () {
            //    parentRect.borders.bottom.push(exportPDF.extractBorders($(this)[0], 'bottom'));
            //});

            pageStatus.borders[parentRect.id] = parentRect;

            html2canvas(document.querySelector(pageStatus.pageList[pageStatus.currentPage]), { scale: exportPDF.scaleFactor, logging: false }).then(canvas => {

                //exportPDF.setDPI(canvas, 192);  edit for page image quality

                // Draws borders.
                //exportPDF.drawBorder(canvas, pageStatus.borders[pageStatus.currentPage].borders.bottom, "bottom");
                //exportPDF.drawBorder(canvas, pageStatus.borders[pageStatus.currentPage].borders.right, "right");

                var width = parseFloat($(pageStatus.pageList[pageStatus.currentPage]).css('width').replace("px", ""));
                var height = parseFloat($(pageStatus.pageList[pageStatus.currentPage]).css('height').replace("px", ""));
                //if (exportPDF.pageStatus.pdfObj == '') exportPDF.pageStatus.pdfObj = new jsPDF('p', 'mm', [canvas.width, canvas.height], true);
                //if (exportPDF.pageStatus.pdfObj == '') exportPDF.pageStatus.pdfObj = new jsPDF('p', 'px', [width, height], true);

                if (exportPDF.pageStatus.pdfObj == '') exportPDF.pageStatus.pdfObj = new jsPDF();

                if (pageStatus.currentPage > 0) {
                    exportPDF.pageStatus.pdfObj.addPage();
                    exportPDF.pageStatus.pdfObj.setPage(pageStatus.currentPage + 1);
                }

                var imageCanvas = canvas.toDataURL('image/jpeg', 1);
                if(imageCanvas.length > 6) {
                    exportPDF.pageStatus.pdfObj.addImage(
                        imageCanvas,
                        0,
                        0,
                        canvas.width,
                        canvas.height,
                        '',
                        'FAST'
                    );
                }

                pageStatus.currentPage++;

                if (pageStatus.currentPage < pageStatus.pageList.length) {
                    exportPDF.composePages(callback);
                } else {
                    callback();
                }

            });
        };

        this.ShowWait = function (show) {

            if (show) {
                $('#export-spinner').removeClass('hidden');
                $('body').css('overflow', 'hidden');
            } else {
                $('#export-spinner').addClass('hidden');
                $('body').css('overflow', 'visible');
            }

        };

        this.generatePDF = function (printableClass) {

            exportPDF.ShowWait(true);

            var printableElementArray = [];
            $(printableClass).each(function () {
                var currentEl = $(this);
                if (currentEl.css('display') != 'none')
                    printableElementArray.push("#" + currentEl.prop('id'));
            });

            exportPDF.pageStatus = {
                pdfObj: "",
                pageList: printableElementArray,
                currentPage: 0,
                pageImages: [],
                canvasSize: {
                    height: 0,
                    width: 0
                },
                borders: []
            };

            window.scroll(0, 0);

            exportPDF.composePages(exportPDF.buildPDF);
        };

        this.generatePDF2 = function (printableClass) {
            //var doc = new jsPDF();
            //var idPage = "cartography-extract-report-1132";

            // Image logo icon
            //var urlImgLogo = $('#' + idPage + ' .plant-report-margin img')[0].getAttribute('src');
            //var widthImgLogo = $('#' + idPage + ' .plant-report-margin img')[0].getAttribute('width');
            //var heightImgLogo = $('#' + idPage + ' .plant-report-margin img')[0].getAttribute('height');
            //myUtility.ToDataUrl(urlImgLogo, function(myBase64) {
            //    doc.addImage(
            //        myBase64,
            //        'JPEG',
            //        20,
            //        20,
            //        widthImgLogo,
            //        heightImgLogo,
            //        '',
            //        'SLOW'
            //        );

            //    doc.save("download.pdf");
            //});

            //var element = document.getElementById('cartography-extract-report-1132');
            //html2pdf(element, {
            //    margin: 1,
            //    filename: 'myfile.pdf',
            //    image: {type: 'jpeg', quality: 1},
            //    html2canvas: {scale: 2, logging: true},
            //    //jsPDF: {unit: 'in', format: 'a4', orientation: 'l'}
            //}).then(canvas => {
            //    doc.save("download.pdf");
            //});

            //var elementHandler = {
            //    '#ignorePDF': function (element, renderer) {
            //        return true;
            //    }
            //};
            //var source = window.document.getElementsByTagName("body")[0];
            //doc.fromHTML(
            //  source,
            //  15,
            //  15,
            //  {
            //      'width': 180,'elementHandlers': elementHandler
            //  });

            //doc.html(document.getElementById('html'), {
            //    callback: function (pdf) {
            //        pdf.save("download.pdf");
            //    }
            //});

            //doc.save("download.pdf");

            let pdf = new jsPDF();
            pdf.html(document.getElementById('cartography-extract-report-1132'), {
                callback: function () {
                    pdf.save('test.pdf');
                    //window.open(pdf.output('bloburl')); // to debug
                }
            });

        };
    };

    /**
     * remove String inside String by array
     */
    this.RemoveStringInsideStringByArray = function (StringOriginal, ArrayStrings) {

        for (var s = 0; s < ArrayStrings.length; s++) {

            if (StringOriginal.indexOf(ArrayStrings[s]) > -1) {

                StringOriginal = StringOriginal.replace(ArrayStrings[s], '');

                return {
                    string: StringOriginal,
                    SelectedArray: ArrayStrings[s]
                }

            }

        }
    }

    // -- end class area --------------------------------------------------------------------------

    /**
     * Image zoom canvas
     * @param {any} imgID
     * @param {any} resultID
     */
    this.ImageZoom = function (imgID, resultID) {
        var img, lens, result, cx, cy;
        img = document.getElementById(imgID);
        result = document.getElementById(resultID);
        // Remove lens
        $('.img-zoom-lens').remove();
        /* Create lens: */
        lens = document.createElement("DIV");
        lens.setAttribute("class", "img-zoom-lens");
        /* Insert lens: */
        img.parentElement.insertBefore(lens, img);
        /* Calculate the ratio between result DIV and lens: */
        cx = result.offsetWidth / lens.offsetWidth;
        cy = result.offsetHeight / lens.offsetHeight;

        /* Set background properties for the result DIV */
        result.style.backgroundImage = "url('" + img.src + "')";
        result.style.backgroundSize = (img.width * cx) + "px " + (img.height * cy) + "px";
        /* Execute a function when someone moves the cursor over the image, or the lens: */
        lens.addEventListener("mousemove", moveLens);
        img.addEventListener("mousemove", moveLens);
        /* And also for touch screens: */
        lens.addEventListener("touchmove", moveLens);
        img.addEventListener("touchmove", moveLens);
        function moveLens(e) {
            var pos, x, y;
            /* Prevent any other actions that may occur when moving over the image */
            e.preventDefault();
            /* Get the cursor's x and y positions: */
            pos = getCursorPos(e);

            //console.log(pos);

            /* Calculate the position of the lens: */
            x = pos.x - (lens.offsetWidth / 2);
            y = pos.y - (lens.offsetHeight / 2);
            /* Prevent the lens from being positioned outside the image: */
            if (x > img.width - lens.offsetWidth) { x = img.width - lens.offsetWidth; }
            if (x < 0) { x = 0; }
            if (y > img.height - lens.offsetHeight) { y = img.height - lens.offsetHeight; }
            if (y < 0) { y = 0; }
            /* Set the position of the lens: */
            lens.style.left = x + "px";
            lens.style.top = y + "px";
            /* Display what the lens "sees": */
            result.style.backgroundPosition = "-" + (x * cx) + "px -" + (y * cy) + "px";
        }
        function getCursorPos(e) {
            var a, x = 0, y = 0;
            e = e || window.event;
            /* Get the x and y positions of the image: */
            a = img.getBoundingClientRect();
            /* Calculate the cursor's x and y coordinates, relative to the image: */
            x = e.pageX - a.left;
            y = e.pageY - a.top;
            /* Consider any page scrolling: */
            x = x - window.pageXOffset;
            y = y - window.pageYOffset;
            return { x: x, y: y };
        }
    }

    /**
     * Zoom image
     * @param {any} idImageZone
     * @param {any} idImagetoZoom
     * @param {any} idImageZoomResult
     * @param {any} imageUrl
     */
    this.ImageZoomer = function (idImageZone, idImagetoZoom, idImageZoomResult, imageUrl)
    {
        //$('#' + idImageZoomResult).css("background: url('" + imageUrl + "') no-repeat #FFF;")

        var imageZoomResult = document.getElementById(idImageZoomResult);

        imageZoomResult.style.backgroundImage = "url('" + imageUrl + "')"; //url("/images/legend\baiao\perigosidade.jpg"); // "url('" + imageUrl + "')";

        var imageZone = document.getElementById(idImageZone);
        imageZone.addEventListener("mousemove", viewZoom);

        function viewZoom(e) {
            let original = document.getElementById(idImagetoZoom),
                magnified = document.getElementById(idImageZoomResult),
                style = magnified.style,
                pos = getCursorPos(e),
                x = pos.x,
                y = pos.y,
                //x = e.pageX - this.offsetLeft,
                //y = e.pageY - this.offsetTop,
                imgWidth = original.offsetWidth,
                imgHeight = original.offsetHeight,
                xperc = ((x / imgWidth) * 100),
                yperc = ((y / imgHeight) * 100);

            //lets user scroll past right edge of image
            if (x > (.01 * imgWidth)) {
                xperc += (.15 * xperc);
            };

            //lets user scroll past bottom edge of image
            if (y >= (.01 * imgHeight)) {
                yperc += (.15 * yperc);
            };

            style.backgroundPositionX = (xperc - 9) + '%';
            style.backgroundPositionY = (yperc - 9) + '%';

            style.left = (x - 120) + 'px';
            style.top = (y - 120) + 'px';
        }

        function getCursorPos(e) {
            var a, x = 0, y = 0;
            e = e || window.event;
            /* Get the x and y positions of the image: */
            a = document.getElementById(idImagetoZoom).getBoundingClientRect();
            /* Calculate the cursor's x and y coordinates, relative to the image: */
            x = e.pageX - a.left;
            y = e.pageY - a.top;
            /* Consider any page scrolling: */
            x = x - window.pageXOffset;
            y = y - window.pageYOffset;
            return { x: x, y: y };
        }
    }

    /**
     * Magnify Image
     * @param {any} idImagetoZoom
     * @param {any} idImageZoomResult
     * @param {any} imageUrl
     * @param {any} zoom
     */
    this.MagnifyImage = function (idImagetoZoom, idImageZoomResult, imageUrl, zoom) //(imgID, zoom)
    {
        var img, glass, w, h, bw;
        img = document.getElementById(idImagetoZoom);

        /* Get magnifier glass: */
        glass = document.getElementById(idImageZoomResult);
        //glass.setAttribute("class", "img-magnifier-glass");

        /* Insert magnifier glass: */
        //img.parentElement.insertBefore(glass, img);

        /* Set background properties for the magnifier glass: */
        glass.style.backgroundImage = "url('" + imageUrl + "')";
        glass.style.backgroundRepeat = "no-repeat";
        glass.style.backgroundSize = (img.width * zoom) + "px " + (img.height * zoom) + "px";
        bw = 3;
        w = glass.offsetWidth / 2;
        h = glass.offsetHeight / 2;

        /* Execute a function when someone moves the magnifier glass over the image: */
        glass.addEventListener("mousemove", moveMagnifier);
        img.addEventListener("mousemove", moveMagnifier);

        /*and also for touch screens:*/
        glass.addEventListener("touchmove", moveMagnifier);
        img.addEventListener("touchmove", moveMagnifier);
        function moveMagnifier(e) {
            var pos, x, y;
            /* Prevent any other actions that may occur when moving over the image */
            e.preventDefault();
            /* Get the cursor's x and y positions: */
            pos = getCursorPos(e);
            x = pos.x;
            y = pos.y;
            /* Prevent the magnifier glass from being positioned outside the image: */
            if (x > img.width - (w / zoom)) { x = img.width - (w / zoom); }
            if (x < w / zoom) { x = w / zoom; }
            if (y > img.height - (h / zoom)) { y = img.height - (h / zoom); }
            if (y < h / zoom) { y = h / zoom; }
            /* Set the position of the magnifier glass: */
            glass.style.left = (x - w) + "px";
            glass.style.top = (y - h) + "px"; //(parseInt($('#id-base-map-legend-img-zone').position().top) + (y - h)) + "px";
            /* Display what the magnifier glass "sees": */
            glass.style.backgroundPosition = "-" + ((x * zoom) - w + bw) + "px -" + ((y * zoom) - h + bw) + "px";
        }

        function getCursorPos(e) {
            var a, x = 0, y = 0;
            e = e || window.event;
            /* Get the x and y positions of the image: */
            a = img.getBoundingClientRect();
            /* Calculate the cursor's x and y coordinates, relative to the image: */
            x = e.pageX - a.left;
            y = e.pageY - a.top;
            /* Consider any page scrolling: */
            x = x - window.pageXOffset;
            y = y - window.pageYOffset;
            return { x: x, y: y };
        }
    }

    /**
     * Delay instruction
     * @param {any} time
     */
    this.Delay = function (time) {
        return new Promise(resolve => setTimeout(resolve, time));
    };

    /**
     * Value Between
     * @param {any} v, value
     * @param {any} min, min limit
     * @param {any} max, max limit
     */
    this.ValBetween = function(v, min, max) {
        return Math.min(max, Math.max(min, v));
    }

    /**
     * Get random int between to number
     * @param {any} min, int min value limit
     * @param {any} max, int max value limit
     */
    this.GetRandomInt = function(min, max) {
        min = Math.ceil(min);   // Round up to the nearest integer
        max = Math.floor(max);  // Round down to the nearest integer
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }
};